import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "year-month-selector" }
const _hoisted_2 = { class: "input-text" }
const _hoisted_3 = {
  key: 0,
  class: "dropdown-modal"
}
const _hoisted_4 = { class: "dropdown-content" }
const _hoisted_5 = { class: "year-section" }
const _hoisted_6 = { class: "month-section" }
const _hoisted_7 = { class: "month-grid" }
const _hoisted_8 = ["disabled", "onClick"]

import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';

interface Props {
  modelValue?: string;
  label?: string;
  prependInnerIcon?: string;
  variant?: string;
  density?: string;
  rules?: any[];
  hideDetails?: boolean;
}

interface Emits {
  (e: 'update:modelValue', value: string): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'YearMonthSelector',
  props: {
    modelValue: {},
    label: { default: '년월 선택' },
    prependInnerIcon: { default: 'mdi-calendar' },
    variant: { default: 'outlined' },
    density: { default: 'compact' },
    rules: {},
    hideDetails: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const store = useStore();

// 반응형 데이터
const isOpen = ref(false);
const selectedYear = ref<number | null>(null);
const selectedMonth = ref<number | null>(null);
const isDisabled = ref(false);

// 년도 옵션 (2025년부터 현재 년도까지)
const currentYear = new Date().getFullYear();
const yearOptions = computed(() => {
  const years = [];
  for (let i = 2025; i <= currentYear; i++) {
    years.push(i);
  }
  return years;
});

// 한 달 전 연월 계산
const getLastMonthYearMonth = () => {
  const now = new Date();
  const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const year = lastMonth.getFullYear();
  const month = lastMonth.getMonth() + 1;
  return normalizeYearMonth(year, month);
};

// 월 옵션
const monthOptions = [
  { value: 1, label: '1월' },
  { value: 2, label: '2월' },
  { value: 3, label: '3월' },
  { value: 4, label: '4월' },
  { value: 5, label: '5월' },
  { value: 6, label: '6월' },
  { value: 7, label: '7월' },
  { value: 8, label: '8월' },
  { value: 9, label: '9월' },
  { value: 10, label: '10월' },
  { value: 11, label: '11월' },
  { value: 12, label: '12월' }
];

// 표시값
const displayValue = computed(() => {
  if (props.modelValue && props.modelValue.length === 6) {
    const year = props.modelValue.substring(0, 4);
    const month = props.modelValue.substring(4, 6);
    return `${year}년 ${parseInt(month)}월`;
  }
  return '';
});

const storeLebYm = computed(() => store.state.lebYm);

const normalizeYearMonth = (year: number, month: number) => {
  return `${year}${month.toString().padStart(2, '0')}`;
};

const syncStoreWithValue = (value?: string) => {
  if (!value || value.length !== 6) return;
  if (store.state.lebYm !== value) {
    store.commit('setLebYm', value);
  }
};

// 드롭다운 토글
const toggleDropdown = () => {
  if (isOpen.value) {
    closeDropdown();
  } else {
    openDropdown();
  }
};

// 드롭다운 열기
const openDropdown = () => {
  isOpen.value = true;
  // 현재 값이 있으면 파싱해서 선택
  if (props.modelValue && props.modelValue.length === 6) {
    selectedYear.value = parseInt(props.modelValue.substring(0, 4));
    selectedMonth.value = parseInt(props.modelValue.substring(4, 6));
  } else {
    // 기본값 설정 (한 달 전)
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    selectedYear.value = lastMonth.getFullYear();
    selectedMonth.value = lastMonth.getMonth() + 1;
  }
};


// 연도 선택
const onYearChange = (year: number | null) => {
  if (isDisabled.value || !year) return;
  
  selectedYear.value = year;
  // 연도 선택 시 즉시 업데이트
  if (selectedMonth.value) {
    const yearMonth = normalizeYearMonth(year, selectedMonth.value);
    emit('update:modelValue', yearMonth);
    syncStoreWithValue(yearMonth);
  }
  
  // 1초간 비활성화
  disableButtons();
};

// 월 선택
const selectMonth = (month: number) => {
  if (isDisabled.value) return;
  
  selectedMonth.value = month;
  // 월 선택 시 즉시 업데이트
  if (selectedYear.value) {
    const yearMonth = normalizeYearMonth(selectedYear.value, month);
    emit('update:modelValue', yearMonth);
    syncStoreWithValue(yearMonth);
    // 연도와 월이 모두 선택되어 있으면 드롭다운 닫기
    closeDropdown();
  }
  
  // 1초간 비활성화
  disableButtons();
};


// 버튼 비활성화 함수
const disableButtons = () => {
  isDisabled.value = true;
  setTimeout(() => {
    isDisabled.value = false;
  }, 1000);
};

// 드롭다운 닫기
const closeDropdown = () => {
  isOpen.value = false;
};

// 외부 클릭 감지
const handleClickOutside = (event: Event) => {
  const target = event.target as HTMLElement;
  // v-select 메뉴는 body에 teleport되므로 별도로 체크
  if (!target.closest('.year-month-selector') && !target.closest('.v-overlay')) {
    closeDropdown();
  }
};

const initializeFromStore = () => {
  const storedValue = storeLebYm.value;
  if (storedValue && storedValue.length === 6) {
    if (props.modelValue !== storedValue) {
      emit('update:modelValue', storedValue);
    }
    return;
  }
  if (props.modelValue && props.modelValue.length === 6) {
    syncStoreWithValue(props.modelValue);
    return;
  }
  // 기본값: 한 달 전 연월
  const lastMonthYm = getLastMonthYearMonth();
  emit('update:modelValue', lastMonthYm);
  syncStoreWithValue(lastMonthYm);
};

watch(
  () => props.modelValue,
  (value) => {
    syncStoreWithValue(value);
  }
);

watch(
  storeLebYm,
  (value) => {
    if (value && value.length === 6 && value !== props.modelValue) {
      emit('update:modelValue', value);
    }
  }
);

// 이벤트 리스너 등록/해제
onMounted(() => {
  initializeFromStore();
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "input-wrapper",
      onClick: toggleDropdown
    }, [
      _createVNode(_component_v_icon, { class: "input-icon" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.prependInnerIcon), 1)
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_2, _toDisplayString(displayValue.value || __props.label), 1),
      _createVNode(_component_v_icon, { class: "dropdown-icon" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isOpen.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
        ]),
        _: 1
      })
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section-title" }, "연도 선택", -1)),
              _createVNode(_component_v_select, {
                modelValue: selectedYear.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((selectedYear).value = $event)),
                  onYearChange
                ],
                items: yearOptions.value,
                disabled: isDisabled.value,
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                "menu-props": { zIndex: 10000 }
              }, null, 8, ["modelValue", "items", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "section-title" }, "월 선택", -1)),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(monthOptions, (month) => {
                  return _createElementVNode("button", {
                    key: month.value,
                    class: _normalizeClass(["month-button", { active: selectedMonth.value === month.value, disabled: isDisabled.value }]),
                    disabled: isDisabled.value,
                    onClick: ($event: any) => (selectMonth(month.value))
                  }, _toDisplayString(month.label), 11, _hoisted_8)
                }), 64))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})